"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shareFormProps = exports["default"] = exports.ShareForm = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _reduxForm = require("redux-form");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ui = require("@unite-us/ui");
var _classnames = _interopRequireDefault(require("classnames"));
var _lodash = require("lodash");
var _validations = require("./validations");
var _InfoPopover = _interopRequireDefault(require("../../InfoPopover"));
var _constants = require("./constants");
var _ShareForm = require("../ShareForm");
var _LanguageSelector = _interopRequireDefault(require("../../consent/LanguageSelector"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var MESSAGE_TYPE_VALUES = {
  PHONE: 'sms',
  EMAIL: 'email',
  PRINT: 'print'
};
var ShareForm = exports.ShareForm = /*#__PURE__*/function (_Component) {
  _inherits(ShareForm, _Component);
  var _super = _createSuper(ShareForm);
  function ShareForm() {
    var _this;
    _classCallCheck(this, ShareForm);
    _this = _super.call(this);
    _this.onCancel = _this.onCancel.bind(_assertThisInitialized(_this));
    _this.onPrint = _this.onPrint.bind(_assertThisInitialized(_this));
    _this.onSend = _this.onSend.bind(_assertThisInitialized(_this));
    _this.onChangeOrReset = _this.onChangeOrReset.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(ShareForm, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var _this$props = this.props,
        open = _this$props.open,
        reset = _this$props.reset;
      if (open && nextProps.open === false) {
        reset();
      }
    }
  }, {
    key: "onCancel",
    value: function onCancel() {
      this.props.reset();
      this.props.onCancel();
    }
  }, {
    key: "onSend",
    value: function onSend(values) {
      var _this2 = this;
      var email = values.email,
        messageType = values.messageType,
        phone = values.phone;
      var to = {
        email: email,
        sms: phone
      };
      return Promise.resolve(this.props.onSend({
        messageType: messageType,
        to: to[messageType]
      })).then(function (response) {
        if (!(0, _lodash.isError)(response)) {
          _this2.props.onTrackShare({
            messageType: messageType,
            to: to[messageType]
          });
          _this2.onCancel();
        }
      });
    }
  }, {
    key: "onPrint",
    value: function onPrint(event) {
      // Prevent submission of the form.
      event.preventDefault();
      var _this$props2 = this.props,
        handlePrint = _this$props2.handlePrint,
        sharedGroups = _this$props2.sharedGroups,
        sharesUrl = _this$props2.sharesUrl,
        language = _this$props2.language;
      var sharedGroupIds = (0, _lodash.map)(sharedGroups, 'id').join(',');
      var url = language ? "".concat(sharesUrl, "/?groupId=").concat(sharedGroupIds, "&language=").concat(language, "&print=true") : "".concat(sharesUrl, "/?groupId=").concat(sharedGroupIds, "&print=true");
      var win = handlePrint(url, '_blank');
      this.props.onTrackShare({
        messageType: MESSAGE_TYPE_VALUES.PRINT
      });
      if ((0, _lodash.isFunction)(this.props.onPrint)) {
        this.props.onPrint();
      }
      if (win && (0, _lodash.isFunction)(win.focus)) {
        win.focus();
      }
      return win;
    }
  }, {
    key: "onChangeOrReset",
    value: function onChangeOrReset() {
      if (this.props.onChangeMessageType === _lodash.noop) {
        this.props.reset();
      }
      this.props.onChangeMessageType();
    }
  }, {
    key: "messageTypeOptions",
    value: function messageTypeOptions(id) {
      return [{
        label: /*#__PURE__*/_react["default"].createElement("span", {
          className: "sms-cont"
        }, "Text", /*#__PURE__*/_react["default"].createElement(_InfoPopover["default"], {
          id: "".concat(id, "-sms-info"),
          placement: "right"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "share-form__popover-content"
        }, _constants.SHARE_FORM_POPOVER_CONTENT))),
        value: MESSAGE_TYPE_VALUES.PHONE
      }, {
        label: 'Email',
        value: MESSAGE_TYPE_VALUES.EMAIL
      }, {
        label: 'Print',
        value: MESSAGE_TYPE_VALUES.PRINT
      }];
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        className = _this$props3.className,
        handleSubmit = _this$props3.handleSubmit,
        hideCancelButton = _this$props3.hideCancelButton,
        id = _this$props3.id,
        messageType = _this$props3.messageType,
        handleOnChange = _this$props3.handleOnChange,
        language = _this$props3.language,
        sendProviderOpen = _this$props3.sendProviderOpen,
        open = _this$props3.open,
        languageSelectorWidth = _this$props3.languageSelectorWidth;
      var EMAIL = MESSAGE_TYPE_VALUES.EMAIL,
        PHONE = MESSAGE_TYPE_VALUES.PHONE,
        PRINT = MESSAGE_TYPE_VALUES.PRINT;
      return /*#__PURE__*/_react["default"].createElement("form", {
        className: (0, _classnames["default"])('share-form', className),
        id: id,
        onSubmit: handleSubmit(this.onSend)
      }, /*#__PURE__*/_react["default"].createElement(_reduxForm.Field, {
        className: "share-form__message-type-field",
        component: _ui.RadioField,
        id: "share-message-type",
        inline: true,
        label: "Share Method",
        name: "messageType",
        onChange: this.onChangeOrReset,
        options: this.messageTypeOptions(id)
      }), messageType === PHONE && /*#__PURE__*/_react["default"].createElement(_reduxForm.Field, {
        component: _ui.InputField,
        id: "share-phone-field",
        label: "Phone Number",
        name: "phone",
        required: true,
        validate: [_validations.requiredValidation, _validations.phoneNumberValidation]
      }), messageType === EMAIL && /*#__PURE__*/_react["default"].createElement(_reduxForm.Field, {
        component: _ui.InputField,
        id: "share-email-field",
        label: "Email",
        name: "email",
        required: true,
        validate: [_validations.requiredValidation, _validations.emailValidation]
      }), (sendProviderOpen || open) && /*#__PURE__*/_react["default"].createElement("div", {
        className: "mb-16"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "absolute"
      }, /*#__PURE__*/_react["default"].createElement(_LanguageSelector["default"], {
        onChange: handleOnChange,
        field: {
          value: language
        },
        theme: {
          width: languageSelectorWidth
        },
        appContext: "shares"
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "share-form__buttons"
      }, !hideCancelButton && /*#__PURE__*/_react["default"].createElement(_ui.Button, {
        className: "mr-half",
        id: "share-cancel-button",
        label: "Cancel",
        onClick: this.onCancel,
        secondary: true
      }), messageType === PRINT ? /*#__PURE__*/_react["default"].createElement(_ui.Button, {
        id: "share-print-button",
        label: "Print",
        onClick: this.onPrint,
        primary: true
      }) : /*#__PURE__*/_react["default"].createElement(_ui.Button, {
        id: "share-send-button",
        label: "Send",
        primary: true,
        type: "submit"
      })));
    }
  }]);
  return ShareForm;
}(_react.Component);
var shareFormProps = exports.shareFormProps = {
  /** class name */
  className: _propTypes["default"].string,
  /** indicates location to store form in redux state, defaults to 'form' */
  formStore: _propTypes["default"].oneOf(['form', 'form7']),
  // eslint-disable-line
  /** redux form method to connect to redux state, defaults to state => state.form */
  getFormState: _propTypes["default"].func,
  // eslint-disable-line
  /** selected language */
  language: _propTypes["default"].string,
  /** width of language selector */
  languageSelectorWidth: _propTypes["default"].string,
  /** base url for shares app */
  handleOnChange: _propTypes["default"].func,
  /** handlePrint the function used to spawn a new window with the share information, defaults to `window.open` */
  handlePrint: _propTypes["default"].func,
  /** redux form handleSubmit function */
  handleSubmit: _propTypes["default"].func.isRequired,
  /** hides cancel button, defaults to false */
  hideCancelButton: _propTypes["default"].bool,
  /** id required for generating and reading unique popover id */
  id: _propTypes["default"].string.isRequired,
  /** is provider detail expandable container open */
  sendProviderOpen: _propTypes["default"].bool,
  /** message type field, defaults to 'sms' */
  messageType: _propTypes["default"].oneOf(['sms', 'email', 'print']),
  /** called on cancel */
  onCancel: _propTypes["default"].func,
  /** called on print */
  onPrint: _propTypes["default"].func,
  /** onChange function for message type radio field */
  onChangeMessageType: _propTypes["default"].func,
  /** called on sending email or sms */
  onSend: _propTypes["default"].func,
  /** tracking function called when printing/sending message */
  onTrackShare: _propTypes["default"].func,
  /** open/closed state of drawer */
  open: _propTypes["default"].bool,
  /** redux form reset function */
  reset: _propTypes["default"].func.isRequired,
  /** shared groups with ids to construct complete shares url */
  sharedGroups: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    id: _propTypes["default"].string.isRequired
  })).isRequired,
  /** base shares url to go to on print */
  sharesUrl: _propTypes["default"].string.isRequired
};
ShareForm.propTypes = shareFormProps;
ShareForm.defaultProps = {
  className: '',
  email: undefined,
  formStore: 'form',
  handleOnChange: _lodash.noop,
  // getFormState: state => state.form, This is the default, but adding the defaultProp here does nothing
  handlePrint: window.open,
  hideCancelButton: false,
  sendProviderOpen: false,
  language: 'en',
  languageSelectorWidth: '20rem',
  messageType: 'sms',
  onCancel: _lodash.noop,
  onPrint: _lodash.noop,
  onChangeMessageType: _lodash.noop,
  onSend: _lodash.noop,
  onTrackShare: _lodash.noop,
  open: false,
  phone: undefined
};
function mapStateToProps(state, ownProps) {
  // Default formState value to 'form' because default prop isn't set yet at
  // this point.
  var _ownProps$formStore = ownProps.formStore,
    formStore = _ownProps$formStore === void 0 ? 'form' : _ownProps$formStore;
  var selector = (0, _reduxForm.formValueSelector)(_ShareForm.SHARE_FORM, function (reduxState) {
    return reduxState[formStore];
  });
  var messageType = selector(state, 'messageType');
  return {
    initialValues: {
      messageType: 'sms'
    },
    messageType: messageType
  };
}
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps)((0, _reduxForm.reduxForm)({
  form: 'share',
  destroyOnUnmount: false
})(ShareForm));